import { render, staticRenderFns } from "./topic-mobile.vue?vue&type=template&id=1a26b631"
import script from "./topic-mobile.vue?vue&type=script&lang=js"
export * from "./topic-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports